import controller from '../../Controller.js';
// import './Styles.css'; // imported from main bundle

function InstantSearch(input) {

    var searchContainer;
    var request = new XMLHttpRequest();
    var textFieldTimer;

    function init() {
        console.log("enter init index.js (InstantSearch)");
        window.addEventListener('focusin', handleFocusOutsideSearchBox);
        input.addEventListener('input', handleSearch);

        window.addEventListener('click', handleFocusOutsideSearchBox);

    }
    function handleFocusOutsideSearchBox(event) {
        if (event.target.closest('.instantsearch__container') == null && event.target.closest('.instantsearch__container__startpage') == null) {
            hideAutosuggestDropdown();
        }
        else {
            console.log("Innanf�r");
            console.dir(event.target);
            showAutosuggestDropdown();
        }
    }

    function hideAutosuggestDropdown() {
        console.log("hideAutosuggestDropdown()");
        if (searchContainer) {
            console.log("QQQQQQQQQQQQQQQQQQQQQQQQQQQQQQ__555::: " + searchContainer.classList);
            searchContainer.classList.add('hidden');
            searchContainer.remove();
        }
        var autosuggestContainer = document.querySelectorAll('.instantsearch__container')[0];
        if (autosuggestContainer == null) autosuggestContainer = document.querySelectorAll('.instantsearch__container__startpage')[0];
        if (autosuggestContainer) {
            console.log("QQQQQQQQQQQQQQQQQQQQQQQQQQQQQQ__666");
            console.log("autosuggestContainer.classList.add('autosuggest__dropdown__visible');");
            autosuggestContainer.classList.remove('autosuggest__dropdown__visible');
        }
    }
    function showAutosuggestDropdown() {
        console.log("showAutosuggestDropdown()");
        if (searchContainer) {
            console.log("QQQQQQQQQQQQQQQQQQQQQQQQQQQQQQ__777");
            searchContainer.classList.remove('hidden'); 
        }
        var autosuggestContainer = document.querySelectorAll('.instantsearch__container')[0];
        if (autosuggestContainer == null) autosuggestContainer = document.querySelectorAll('.instantsearch__container__startpage')[0];
        if (autosuggestContainer) {
            console.log("QQQQQQQQQQQQQQQQQQQQQQQQQQQQQQ__888");
            autosuggestContainer.classList.add('autosuggest__dropdown__visible');
        }
    }
    //function hideInputBorder() {
    //    console.log("hideInputBorder()");
    //    if (searchContainer) {
    //        console.log("inside if");
    //        searchContainer.classList.add('hide-border');
    //    }
    //}

    function handleSearchClick() {
        searchContainer = document.querySelectorAll('.instantsearch')[0];
        if (searchContainer) {
            //hideInputBorder();
            hideAutosuggestDropdown();
        }
    }
  function handleSearch(e) {
      searchContainer = document.querySelectorAll('.instantsearch')[0];
      


      clearTimeout(textFieldTimer);

      


      var query = this.value;
      

      if (query.length > 2) {
          var autosuggest = document.querySelectorAll(".instantsearch")[0];
          if (autosuggest && autosuggest.classList.contains('hidden')) {
              autosuggest.classList.remove('hidden');
          }
          
	    textFieldTimer = setTimeout(function() {
        showSearchContainerAndFetchResult(query);
		    },
            500);
    }
    else {
      removeSearchContainer();
    }
    }

    function showSearchContainerAndFetchResult(query) {

    input.setAttribute('data-loading', 'true');
    fetchResult(query).then((result) => {
      input.setAttribute('data-loading', 'false');
        if (!searchContainer) {
            searchContainer = document.createElement('div');
            searchContainer.classList.add('autosuggest');

            if (searchContainer) {
                if (searchContainer.querySelectorAll('.instantsearch_suggestion').length > 0) {
                    console.log("FETCH ---- SHOW");
                    showAutosuggestDropdown();
                }
                else {
                    console.log("FETCH ---- HIDE");
                    hideAutosuggestDropdown();
                }
            }

            input.insertAdjacentElement('afterend', searchContainer);
            input.classList.add('autosuggest-active');
            document.body.addEventListener('click', removeSearchContainer);
            document.addEventListener('keydown', handleEscKeyPress);
            searchContainer.addEventListener('click', (e) => {
          e.stopPropagation();
        })
        }
        searchContainer.innerHTML = result;
        
        var autosuggestTitle = document.querySelectorAll('.instantsearch__title')[0];
        if (autosuggestTitle) {
            var className = `number__of__suggestions__${document.querySelectorAll('.instantsearch_suggestion').length}`;
            console.log('className = ' + className);
            autosuggestTitle.classList.add(className);
        }
        //DisplayAutocompleteDropDownCorrectly();
        showAutosuggestDropdown();
    })


    } 
    function DisplayAutocompleteDropDownCorrectly() {
        var inputField = document.querySelectorAll("input.filter__field.filter__field--course-search")[0]
    
        //var suggestionList = document.getElementsByClassName("autosuggest_suggestion");
        console.log("searchContainer outside if-statement:");
    
        //if (inputField != null) {
        //    var autosuggest = document.querySelectorAll(".instantsearch")[0];
        //    // if (autosuggest.classList.contains('hidden')) {
        //    //     autosuggest.classList.remove('hidden');
        //    // }
        //
        //    var ro = new ResizeObserver(entries => {
        //        for (let entry of entries) {
        //            const cr = entry.contentRect;
        //            autosuggest.style.width = `${cr.width+28}px`;
        //        }
        //    });
        //    ro.observe(inputField);
        //}
    
        var autosuggestResults = document.querySelectorAll('.instantsearch__result');
        var courseTypes = document.querySelectorAll('.instantsearch__title')[0];
        var autocompleteSuggestions = document.querySelectorAll('.autocomplete-suggestions')[0];
    
        // if (autosuggestResults.length == 0) {
        //     console.log("RESULT__11111");
        //     if (document.querySelectorAll('.instantsearch__empty') == null) {
        //         console.log("RESULT__22222");
        // 
        //         if (courseTypes) {
        //             console.log("RESULT__33333");
        //             courseTypes.style.marginTop = `${autocompleteSuggestions.offsetHeight}px`;
        //         }
        //     }
        //     if (searchContainer.children.length == 0) {
        //         console.log("RESULT__44444");
        //         //removeSearchContainer();
        //         hideAutosuggestDropdown();
        //     }
        // }
        
        //else if (autosuggestResults.length > 0 && autocompleteSuggestions.offsetHeight != 0) {
        //    console.log("RESULT__02");
        //
        //    if (courseTypes) {
        //        console.log("RESULT__02..1");
        //        
        //        //courseTypes.style.marginTop = `${autocompleteSuggestions.offsetHeight - 20}px`;
        //    }
        //}
        //else {
        //    console.log("RESULT__03");
        //
        //    if (courseTypes) {
        //        console.log("RESULT__03..1");
        //        courseTypes.style.marginTop = `${0}px`;
        //    }
        //}
        
    
        
    }

  function fetchResult(query) {
    request.abort();
      var url = input.getAttribute('data-fetch-url');
    return new Promise((resolve, reject) => {
      request.onreadystatechange = function() {
        if (this.readyState !== 4) return;
        if (this.status === 500) {
          reject();
        }
        if (this.status !== 200) return;
        resolve(this.responseText);
      };
      request.open('POST', url, true);
      request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      request.setRequestHeader('Content-Type', 'application/json');
      request.send(JSON.stringify({query}));
    });
  }

  function handleEscKeyPress(e) {
    if(e.keyCode == 27) {
      removeSearchContainer();
    }
  }

  function removeSearchContainer() {
    request.abort();
    input.setAttribute('data-loading', 'false');
    if(searchContainer) {
      searchContainer.classList.add('hidden');
      input.classList.remove('autosuggest-active');
      document.body.removeEventListener('click', removeSearchContainer);
      document.removeEventListener('keydown', handleEscKeyPress);
      searchContainer = null;
    }
   }


  return {
    init: init
  }
}

controller.add('InstantSearch', InstantSearch);

export default InstantSearch;
